const LinkArea = () => {
  return (
    <div
      css={{
        marginTop: '20px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#FFF',
      }}
    >
      <a
        href='https://okanechips.mei-kyu.com/privacy/'
        target='_blank'
        rel='noreferrer'
        style={{ color: '#FBE21F' }}
      >
        プライバシーポリシー
      </a>
      と
      <a
        href='https://okanechips.mei-kyu.com/terms/'
        target='_blank'
        rel='noreferrer'
        style={{ color: '#FBE21F' }}
      >
        利用規約
      </a>
      に同意した上で
    </div>
  )
}

export default LinkArea
